module.exports = __webpack_public_path__ + "static/media/cris.c80c4673.svg";